import React, { useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext.jsx";
import { ForumProvider, useForum } from "./ForumContext.jsx";
import "./Forum.css";

const DISCIPLINES = [
  { value: "painting",   ar: "الرسم والتصوير الزيتي" },
  { value: "watercolor", ar: "الألوان المائية" },
  { value: "sculpture",  ar: "النحت والخزف" },
  { value: "calligraphy",ar: "الخط والزخرفة" },
  { value: "digital",    ar: "الفن الرقمي" },
  { value: "printmaking",ar: "الطباعة والحفر" },
  { value: "photography",ar: "التصوير الفوتوغرافي" },
  { value: "mixed",      ar: "الوسائط المختلطة" },
  { value: "installation",ar: "فن التجهيز" },
  { value: "video-art",  ar: "فيديو آرت" },
];

const CHARTER = [
  { num: 1,  title: "الاحترام والأدب",          body: "يلتزم الأعضاء بالتعامل المحترم واللغة اللائقة في جميع النقاشات." },
  { num: 2,  title: "الأصالة الفنية",            body: "يُمنع منعاً باتاً انتهاك حقوق الملكية الفكرية ونسب الأعمال لغير أصحابها." },
  { num: 3,  title: "المحتوى الملائم",           body: "يُحظر نشر محتوى مسيء أو عنيف أو يمسّ خصوصية الآخرين." },
  { num: 4,  title: "العضوية الحصرية",           body: "المنتدى حصري لأعضاء SPAR وSPAU الفعليين." },
  { num: 5,  title: "الإشراف الإداري",           body: "للإدارة الحق في حذف أي محتوى مخالف وحظر من يُسيء الاستخدام." },
  { num: 6,  title: "حقوق الإدارة",             body: "تحتفظ SPAR بحق تعديل اللوائح وإضافة أقسام وتنظيم المحتوى." },
  { num: 7,  title: "السرية",                    body: "لا يُسمح بمشاركة نقاشات الأعضاء الخاصة خارج المنتدى." },
  { num: 8,  title: "جودة المحتوى",             body: "يُشجَّع نشر محتوى ذي قيمة فنية، ويُحظر الإعلان التجاري دون إذن." },
  { num: 9,  title: "ملكية المحتوى المنشور",     body: "يحتفظ العضو بحقوق أعماله ويمنح SPAR حق العرض داخل المنتدى." },
  { num: 10, title: "المشاركة الإيجابية",        body: "يُنصح الأعضاء بالمشاركة الفعّالة وتبادل المعرفة والخبرات." },
  { num: 11, title: "الإبلاغ عن المخالفات",     body: "يحق لأي عضو الإبلاغ عن محتوى مخالف للإدارة للمراجعة." },
  { num: 12, title: "القبول والالتزام",          body: "بالانضمام إلى المنتدى يُقرّ العضو بقراءة هذه اللوائح والالتزام بها." },
];

function RegisterPage() {
  const navigate = useNavigate();
  const { isLoggedIn, artist } = useAuth();
  const { isMember, isPending, register } = useForum();

  const [disciplines, setDisciplines] = useState([]);
  const [agreed, setAgreed]           = useState(false);
  const [scrolled, setScrolled]       = useState(false);
  const [notifyReplies, setNotifyReplies]   = useState(true);
  const [notifyMentions, setNotifyMentions] = useState(true);
  const [submitting, setSubmitting]   = useState(false);
  const [error, setError]             = useState("");

  const charterRef = useRef(null);

  if (!isLoggedIn) {
    return (
      <div className="forum-register-wrap" style={{ textAlign: "center", paddingTop: 60 }}>
        <p>يجب تسجيل الدخول أولاً.</p>
        <Link to="/login" className="forum-submit-btn" style={{ display: "inline-block", textDecoration: "none", width: "auto", padding: "12px 32px" }}>دخول SPAR</Link>
      </div>
    );
  }

  if (isPending) {
    return (
      <div className="forum-register-wrap" style={{ textAlign: "center", paddingTop: 60 }}>
        <div style={{ fontSize: "3rem", marginBottom: 16 }}>⏳</div>
        <h2 style={{ fontWeight: 800, color: "var(--text-1)" }}>طلبك قيد المراجعة</h2>
        <p style={{ color: "var(--text-3)" }}>تم استلام طلب انضمامك يا {artist?.name}، وسيتم مراجعته من قِبل الإدارة قريباً.</p>
      </div>
    );
  }

  if (isMember) {
    return (
      <div className="forum-register-wrap" style={{ textAlign: "center", paddingTop: 60 }}>
        <div style={{ fontSize: "3rem", marginBottom: 16 }}>✅</div>
        <h2 style={{ fontWeight: 800, color: "var(--green)" }}>أنت عضو في المنتدى</h2>
        <p style={{ color: "var(--text-3)" }}>مرحباً {artist?.name}، يمكنك المشاركة في جميع النقاشات.</p>
        <Link to="/Forum" className="forum-submit-btn" style={{ display: "inline-block", textDecoration: "none", width: "auto", padding: "12px 32px" }}>اذهب إلى المنتدى ←</Link>
      </div>
    );
  }

  const toggleDiscipline = (v) => {
    setDisciplines(d => d.includes(v) ? d.filter(x => x !== v) : [...d, v]);
  };

  const handleScroll = (e) => {
    const el = e.target;
    if (!scrolled && el.scrollHeight - el.scrollTop - el.clientHeight < 30) setScrolled(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!agreed) return;
    setSubmitting(true);
    setError("");
    try {
      await register(disciplines, notifyReplies, notifyMentions);
    } catch (err) {
      setError(err.response?.data?.error || "حدث خطأ — حاول مرة أخرى.");
      setSubmitting(false);
    }
  };

  return (
    <div className="forum-register-wrap">
      {/* Breadcrumb */}
      <div className="forum-breadcrumb" style={{ direction: "rtl", marginBottom: 24 }}>
        <Link to="/Forum">المنتدى</Link>
        <span className="forum-breadcrumb-sep">›</span>
        <span>انضمام للمنتدى</span>
      </div>

      <h1 style={{ fontWeight: 800, fontSize: "1.5rem", marginBottom: 6 }}>انضمام إلى منتدى SPAR</h1>
      <p style={{ color: "var(--text-3)", fontSize: "0.88rem", marginBottom: 28 }}>
        المنتدى حصري لأعضاء SPAR وSPAU. اقرأ اللوائح بالكامل وأكمل بياناتك للانضمام.
      </p>

      <form onSubmit={handleSubmit}>
        {/* Profile pre-fill notice */}
        <div style={{ background: "var(--teal-light)", border: "1px solid rgba(0,181,184,0.25)", borderRadius: "var(--r-xs)", padding: "12px 16px", fontSize: "0.85rem", marginBottom: 24, display: "flex", gap: 10 }}>
          <span>ℹ️</span>
          <span>سيُستخدم ملفك الشخصي في SPAR تلقائياً — صورتك واسمك وتخصصك.</span>
        </div>

        {/* Disciplines */}
        <div className="forum-form-group">
          <label className="forum-form-label">التخصصات الفنية (اختر ما ينطبق)</label>
          <div className="forum-discipline-grid">
            {DISCIPLINES.map(d => (
              <label key={d.value} className="forum-discipline-chip">
                <input type="checkbox" checked={disciplines.includes(d.value)} onChange={() => toggleDiscipline(d.value)} />
                {d.ar}
              </label>
            ))}
          </div>
        </div>

        {/* Charter */}
        <div className="forum-form-group" style={{ marginTop: 28 }}>
          <label className="forum-form-label">لوائح وميثاق المنتدى — اقرأ حتى النهاية للموافقة</label>
          <div className="forum-charter-box" ref={charterRef} onScroll={handleScroll}>
            {CHARTER.map(art => (
              <div key={art.num} className="forum-charter-article">
                <strong>المادة {art.num}: {art.title}</strong>
                <div style={{ marginTop: 2, color: "var(--text-2)" }}>{art.body}</div>
              </div>
            ))}
          </div>
          {!scrolled && (
            <div style={{ fontSize: "0.78rem", color: "var(--text-3)", marginBottom: 8 }}>
              ↓ مرّر للأسفل لقراءة جميع اللوائح قبل الموافقة
            </div>
          )}
          {scrolled && (
            <div style={{ fontSize: "0.78rem", color: "var(--green)", marginBottom: 8 }}>
              ✓ اطّلعت على اللوائح — يمكنك الموافقة أدناه
            </div>
          )}
          <label className="forum-agree-check">
            <input type="checkbox" checked={agreed} onChange={e => setAgreed(e.target.checked)} disabled={!scrolled} />
            <span>أوافق على جميع لوائح وميثاق منتدى SPAR وأتعهد بالالتزام بها</span>
          </label>
        </div>

        {/* Notifications */}
        <div className="forum-form-group" style={{ marginTop: 20 }}>
          <label className="forum-form-label">إشعارات</label>
          <label className="forum-agree-check" style={{ marginBottom: 8 }}>
            <input type="checkbox" checked={notifyReplies} onChange={e => setNotifyReplies(e.target.checked)} />
            <span>إشعار عند الرد على نقاشاتي</span>
          </label>
          <label className="forum-agree-check">
            <input type="checkbox" checked={notifyMentions} onChange={e => setNotifyMentions(e.target.checked)} />
            <span>إشعار عند الإشارة إليّ</span>
          </label>
        </div>

        {error && <div style={{ color: "var(--red)", fontSize: "0.88rem", marginTop: 12 }}>{error}</div>}

        <button type="submit" className="forum-submit-btn" disabled={!agreed || submitting}>
          {submitting ? "جارٍ التسجيل…" : "تسجيل الانضمام"}
        </button>
      </form>
    </div>
  );
}

export default function ForumRegister() {
  return (
    <ForumProvider>
      <RegisterPage />
    </ForumProvider>
  );
}
